import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { LanguageService } from '@shared/services/language.service';
import { Observable, Subject } from 'rxjs';
import { SelectItem } from 'src/models/general/select.item.model';
import { UntypedFormGroup } from '@angular/forms';
import { takeUntil, tap } from 'rxjs/operators';
import { LanguageCode } from 'iso-639-1';

@Component({
    selector: 'pim-content-language-switch',
    templateUrl: './content-language-switch.component.html',
    styleUrls: ['./content-language-switch.component.sass'],
    standalone: false
})
export class ContentLanguageSwitchComponent implements OnInit, OnChanges, OnDestroy {

	@Input()
	disabled: boolean = false;

	languages$!: Observable<SelectItem[]>;

	form!: UntypedFormGroup;

	private destroy$: Subject<void> = new Subject<void>();

	constructor(private languageService: LanguageService) {
	}

	ngOnInit(): void {
		this.languages$ = this.languageService.getAvailableLanguagesAsSelectItems();
		this.initFormAndListener();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.disabled) {
			this.setNewDisabledStatusOnForm();
		}
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	private initFormAndListener(): void {
		this.form = this.languageService.getContentLanguageForm();

		if (this.disabled) {
			this.form.disable();
			return;
		}

		const contentLangFormControl = this.form.get('contentLanguage');
		if (!contentLangFormControl) {
			throw Error(`Can't find 'contentLanguage' form-control in form`);
		}

		contentLangFormControl.valueChanges.pipe(
			takeUntil(this.destroy$),
			tap((formValue: LanguageCode) => {
				this.languageService.updateContentLanguage(formValue);
			})
		).subscribe();
	}

	private setNewDisabledStatusOnForm(): void {
		if (this.form) {
			this.form.disable();
		}
	}
}
